import type { Nullable, Tables } from "@msuite/utils/types";
import { createContext, useContext } from "react";

/** Interface */
interface IDocumentContext {
	logoUrl: Nullable<string>;
	letterPaperUrl: Nullable<string>;
	workspaceMetadata: Nullable<Tables<"workspaceMeta">>;
}

/** Context */
export const DocumentContext = createContext<IDocumentContext>({} as IDocumentContext);

/** Hooks */
export function useDocumentContext(): IDocumentContext {
	return useContext(DocumentContext);
}
